export const title = 'Cargo Hub Control'

export const constants = {
  DeleteText: 'Are you sure to delete this record?',
  RestoreText: 'Are you sure to restore this record?',
  ResetUser: 'Are you sure to reset password for this user?',
  Dashboard: 'Dashboard',
  SERVER_CONNECTION_ERROR: 'Failed to connect to server',
  NO_DATA_ERROR: 'No Flights Available',
  NO_DATA_AVAILABLE: 'No Data Available'
}

export const systemParameterTabs = {
  fleet: 'fleet',
  recovery_action: 'recovery_action',
  rebooking_teams_sla: 'rebooking_teams_sla',
  dynamic_info: 'dynamic_info',
  breakdown_work_area_mapping: 'breakdown_work_area_mapping',
  product_buildup_priority: 'product_buildup_priority',
  handling_times: 'handling_times',
  grouping: 'grouping',
  buildup_area_mapping: 'buildup_area_mapping',
  uld_mapping: 'uld_mapping',
  haulout_area_mapping: 'haulout_area_mapping',
  dod_milestones: 'dod_milestones',
  w_b: 'w_b',
}

export const pages = {
  INBOUND: 'Inbound Flight Preparation',
  inbound_flight_prep: 'Inbound Flight Preparation',
  BREAKDOWN: 'Breakdown Control',
  breakdown_control: 'Breakdown Control',
  REBOOKING: 'Rebooking Queue',
  rebooking_queue: 'Rebooking Queue',
  BUILDUP: 'Build Up Control',
  buildup_control: 'Build Up Control',
  buildup_dashboard: 'Build Up Dashboard',
  offload_dashboard: 'Offload Dashboard',
}

export const rebookingQueueTabs = {
  pending: 'Pending',
  completed: 'Completed',
  successful: 'Successful',
}

export const gatekeeperTabs = {
  processed: 'Last Processed Messages',
  search: 'Search Messages',
  performance: 'Performance info',
  audit_trail: 'Audit Trail',
}

export const priorityTabs = {
  priority: 'Priority',
  dod_priority: 'DoD Priority',
}

export const changeLogTabs = {
  admin_logs: 'Admin Log',
  system_logs: 'System Log',
}

export const developerDomainTabs = {
  clear_data: 'Clear Data',
  unprocessed_msgs: 'Unprocessed Messages',
  audit: 'Audit Messages',
}

export const events = {
  FFM_OUT_RECEIVED: 'FFM',
  FFM_RECEIVED: 'FFM Received',
  FLIGHT_EVENT: 'Flight Event',
  AWB_UPDATED: 'AWB UPDATED',
  ULD_UPDATED: 'ULD UPDATE',
  BOOKING_MESSAGE: 'ECIBOOK',
  FSU: 'FSU',
  SEGMENT: 'SEGMENT',
  SYS_PARAMS: 'SYSTEM_PARAMETERS',
  RETURN: 'RETURN',
  CANCEL: 'CANCEL',
}

export const station = [
  {
    label: 'ATL',
    value: 'ATL'
  },
  {
    label: 'LAX',
    value: 'LAX'
  },
  {
    label: 'BOS',
    value: 'BOS'
  },
  {
    label: 'JFK',
    value: 'JFK'
  },
  {
    label: 'SEA',
    value: 'SEA'
  },
  {
    label: 'DTW',
    value: 'DTW'
  },
  {
    label: 'MSP',
    value: 'MSP'
  },
  {
    label: 'SLC',
    value: 'SLC'
  },
  {
    label: 'ORD',
    value: 'ORD'
  },
  {
    label: 'HNL',
    value: 'HNL'
  },
  {
    label: 'SFO',
    value: 'SFO'
  },
  {
    label: 'LHR',
    value: 'LHR'
  },
  {
    label: 'DUB',
    value: 'DUB'
  },
  {
    label: 'SNN',
    value: 'SNN'
  },
  {
    label: 'EDI',
    value: 'EDI'
  },
  {
    label: 'LGW',
    value: 'LGW'
  },
]
export const stationTime = {
  ATL: '-0500',
  LAX: '-0800',
  BOS: '-0500',
  JFK: '-0500',
  SEA: '-0800',
  DTW: '-0500',
  MSP: '-0600',
  SLC: '-0700',
  ORD: '-0600',
  HNL: '-1000',
  SFO: '-0800',
  LHR: '+0000',
  DUB: '+0000',
  SNN: '+0000',
  EDI: '+0000',
  LGW: '+0000',
}

export const timezones = {
  ATL: 'America/New_York',
  LAX: 'America/Los_Angeles',
  BOS: 'America/New_York',
  JFK: 'America/New_York',
  SEA: 'America/Los_Angeles',
  DTW: 'America/New_York',
  MSP: 'America/Chicago',
  SLC: 'America/Denver',
  ORD: 'America/Chicago',
  HNL: 'Pacific/Honolulu',
  SFO: 'America/Los_Angeles',
  LHR: 'Europe/London',
  DUB: 'Europe/Dublin',
  SNN: 'Europe/Dublin',
  EDI: 'Europe/London',
  LGW: 'Europe/London',
}

export const timezone = [
  {
    value: 'ATL',
    label: 'ATL',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'LAX',
    label: 'LAX',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'BOS',
    label: 'BOS',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'JFK',
    label: 'JFK',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'SEA',
    label: 'SEA',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'DTW',
    label: 'DTW',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'MSP',
    label: 'MSP',
    zone: 'America/Chicago',
    ext: 'CST',
  },
  {
    value: 'SLC',
    label: 'SLC',
    zone: 'America/Denver',
    ext: 'MST',
  },
  {
    value: 'ORD',
    label: 'ORD',
    zone: 'America/Chicago',
    ext: 'CST',
  },
  {
    value: 'HNL',
    label: 'HNL',
    zone: 'Pacific/Honolulu',
    ext: 'HST',
  },
  {
    value: 'SFO',
    label: 'SFO',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'LHR',
    label: 'LHR',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  {
    value: 'DUB',
    label: 'DUB',
    zone: 'Europe/Dublin',
    ext: 'GMT',
  },
  {
    value: 'SNN',
    label: 'SNN',
    zone: 'Europe/Dublin',
    ext: 'GMT',
  },
  {
    value: 'EDI',
    label: 'EDI',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  {
    value: 'LGW',
    label: 'LGW',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  
]

export const department = [
  {
    label: 'Dept1',
    value: 'Dept1'
  },
  {
    label: 'Dept2',
    value: 'Dept2'
  },
]

export const pagelist = [
  {
    key: '1',
    link: '/gatekeeper',
    title: 'Gatekeeper',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '2',
    link: '/system-parameter',
    title: 'System Parameters',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '3',
    link: '/notes',
    title: 'Notes',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'Re-booking Team', 'User'],
    is_menu: true
  },
  {
    key: '4',
    link: '/inbound-flight',
    title: 'Inbound Flight Preparation',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '5',
    link: '/breakdown-control',
    title: 'Breakdown Control',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '6',
    link: '/rebooking-queue',
    title: 'Rebooking Queue',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'Re-booking Team', 'User'],
    is_menu: true
  },
  {
    key: '7',
    link: '/manage-users',
    title: 'Manage Users',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '8',
    link: '/dod-command-center',
    title: 'DoD Command Center',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'DOD Agent', 'Centralized DoD'],
    is_menu: true
  },
  {
    key: '9',
    link: '/buildup-control',
    title: 'Buildup Control',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '10',
    link: '/breakdown-dashboard',
    title: 'Breakdown Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '11',
    link: '/recovery-dashboard',
    title: 'Recovery Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '12',
    link: '/buildup-dashboard',
    title: 'Buildup Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '13',
    link: '/haulout-dashboard',
    title: 'Haulout Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '14',
    link: '/reports',
    title: 'Reports',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '15',
    link: '/tracking-awbs',
    title: 'Track and Trace AWB',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    stn: ['BOS', 'ATL'],
    is_menu: true
  },
  {
    key: '16',
    link: '/offload-dashboard',
    title: 'Offload Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: false
  }
]

export const errormsg = { sel_work_area: 'Select Work Area' }

export const jsonTheme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#0000',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
}

export const changeLogLabels = {
  //FLEET
  ac_code: 'AC Code',
  aft_conf: 'Aft Hold Config',
  key: 'Aft Hold Config Key',
  name: 'Attachment',
  path: 'Aft Hold Config Path',
  alwd_uld_type: 'Allowed ULDs',
  cont_type: 'Cont Type',
  fwd_conf: 'Fwd Hold Config',
  gen_info: 'Gen Info',
  is_loose: 'Loose',
  is_uld: 'ULD',
  pax_cap: 'Pax Cap',
  //REBOOKING TEAMS & SLA
  q_priority: 'Queue Priority',
  rebook_team: 'Rebooking Team',
  sla_time: 'SLA',
  //RECOVERY ACTION
  action: 'Recovery Action',
  email: 'Email',
  is_breakdown: 'Breakdown',
  is_buildup: 'Buildup',
  is_gen_rebook: 'Gen Rebook',
  is_inbound: 'Inbound',
  is_notify: 'Notify',
  q_to: 'Queue to',
  station_limit: 'Limit to Station',
  recovery_teams_id: 'Recovery Teams ID',
  //DYNAMIC INFO
  ac_type: 'AC Type',
  attach_conf: 'Attachment',
  contry_code: 'Country Code',
  enddate: 'End Date',
  flightno: 'Flight #',
  prod_code: 'Prod Code',
  remarks: 'Remarks',
  spl_code: 'Special Codes',
  startdate: 'Start Date',
  uld_type: 'ULD Type',
  station: 'Station',
  //PWAM
  area_name: 'Work Area Name',
  area_id: 'Area ID',
  p_code: 'Product Code',
  transfer_type: 'Transfer Type',
  location: 'Location',
  //BUP
  priority: 'Priority',
  //HANDLING TIMES
  ac_load: 'AC LOAD',
  ac_offld: 'AC OFFLD',
  at_gate: 'AT GATE',
  bd_store: 'BD & STORE',
  build_up: 'BUILD UP',
  exp_acpt: 'ACCEPT',
  fpe: 'FPE',
  mvt: 'MVT',
  process: 'PROCESS',
  tfr_to_wh: 'TFR TO WH',
  trf_to_ac: 'TFR TO AC',
  indicator_time: 'Amber Indicator',
  //COMMON
  updatedAt: 'Updated At',
  //INBOUND
  uld_dispo: 'ULD Dispo',
  deliver_to: 'Deliver To',
  //REBOOKING
  reason: 'Reason',
  status: 'Status',
  rebook_req_datetime: 'Rebooking Requested',
  rebook_comp_datetime: 'Rebooking Completed',
  rebook_undo_datetime: 'Undo Rebooking',
}

export const cut_codes = [
  {
    code: '11U Weight & Balance',
    reasons: [
      'Not Enough Payload Available',
      'Unable to Balance Aircraft',
      'Change in Flight Plan',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other',
    ],
    cutby: 'ALA'
  },
  {
    code: '12U Bulk Out',
    reasons: [
      'Needed Additional Positions for Bags',
      'Lost Space due to Positioning',
      'Unable to Fit within Bin Footprint',
      'Too Much Cargo Staged',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '13R ALA Failed to Load',
    reasons: [
      'Quick Turn/IROP',
      'No GSE Available',
      'No Staffing',
      'ALA Discretion',
      'Weather/Ramp Closed',
      'Overhang/Contour Issue',
      'Safety Concerns',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '15U No Show at Gate',
    reasons: [
      'Late/No Show at Gate',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '16U Late to Gate',
    reasons: [
      'Missing Labels ',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '17U Missing/Incorrect DG Info',
    reasons: [
      'Missing/Incorrect DG Info',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '18U Damaged FRT/ULD',
    reasons: [
      'Damaged FRT/ULD',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '19U Placard/RWS Discrepancy',
    reasons: [
      'Placard/RWS Discrepancy',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '20U Missing/Damaged Straps/Nets',
    reasons: [
      'Missing/Damaged Straps/Nets',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '21U Strap Point Inop',
    reasons: [
      'Strap Point Inop',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '36U Aircraft Mechanical',
    reasons: [
      'Aircraft Mechanical',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '51C Pilot Refusal',
    reasons: [
      'Pilot Refusal',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: 'ALA Cut via ALIS',
    reasons: [
      'Not Enough Payload Available',
      'Unable to Balance Aircraft',
      'Needed Additional Positions for Bags',
      'Unable to Fit Within Bin Footprint',
      'Lost Space due to Positioning',
      'ALA Failed to Load',
      'No Show/Late to Gate',
      'Too Much Cargo Staged',
      'ULD Damaged',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'LCC'
  },
  {
    code: 'LCC Cut via ALIS',
    reasons: [
      'Manually Cut by LCC Agent',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'OPN',
    reasons: [
      'Cargo Missed FPE',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'TOW',
    reasons: [
      'Planned Payload Exceeds Max Payload',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'WGT',
    reasons: [
      'Max Bin Weight or ULD Gross Weight Exceeded',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'ZFW',
    reasons: [
      'Planned Payload Exceeds Max Payload',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: '34U Flight Cancelled',
    reasons: [
      'Pallet Stack',
      'Wrong Equipment Used',
      'N/A',
    ],
    cutby: 'N/A'
  }
]

export const audit_status = [
  {
    key: '1',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '2',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '3',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '4',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '5',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '6',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '7',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '8',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '9',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '10',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '11',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '12',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '13',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '14',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '15',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '16',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '17',
    audit_submitted: 'No',
    planned_accordingly: null,
    optimal: null,
    meet_wgt_goal: null,
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'grey'
  },
  {
    key: '18',
    audit_submitted: 'No',
    planned_accordingly: null,
    optimal: null,
    meet_wgt_goal: null,
    num_of_rides: 'greater',
    emote: 'FrownOutlined',
    color: 'grey'
  },
]

export const ldd_status = [
  {
    key: '1',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '2',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '3',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '4',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '5',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '6',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '7',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '8',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '9',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '10',
    pallets_paired: null,
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'red'
  },
  {
    key: '1',
    pallets_paired: null,
    pallets_paired_contact: null,
    conveyances_staged: null,
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'grey'
  },

]

export const ch_wt_goals = [
  {
    lane: 'ATLANC',
    kg: 411.4180255,
    lbs: 907.0214861
  },
  {
    lane: 'ATLBOS',
    kg: 498.6359826,
    lbs: 1099.304313
  },
  {
    lane: 'ATLHNL',
    kg: 435.6254338,
    lbs: 960.3898136
  },
  {
    lane: 'ATLJFK',
    kg: 553.46480182,
    lbs: 1220.181185
  },
  {
    lane: 'ATLLAS',
    kg: 2595.6357218,
    lbs: 5722.39799
  },
  {
    lane: 'ATLLAX',
    kg: 532.75524021,
    lbs: 1174.52441
  },
  {
    lane: 'ATLMCO',
    kg: 472.95177091,
    lbs: 1042.680312
  },
  {
    lane: 'ATLMIA',
    kg: 123.09836306,
    lbs: 271.385472
  },
  {
    lane: 'ATLMSP',
    kg: 308.06301893,
    lbs: 679.1627907
  },
  {
    lane: 'ATLPHX',
    kg: 602.2743233,
    lbs: 1327.787774
  },
  {
    lane: 'ATLSFO',
    kg: 386.13638503,
    lbs: 851.2851226
  },
  {
    lane: 'ATLSLC',
    kg: 248.7882401,
    lbs: 548.484255
  },
  {
    lane: 'ATLTPA',
    kg: 329.34819792,
    lbs: 726.088584
  },
  {
    lane: 'DTWHNL',
    kg: 377.89441763,
    lbs: 833.1146924
  },
  {
    lane: 'JFKATL',
    kg: 471.24732572,
    lbs: 1038.922653
  },
  {
    lane: 'JFKDEN',
    kg: 278.80627776,
    lbs: 614.6627087
  },
  {
    lane: 'JFKHNL',
    kg: 317.34298602,
    lbs: 699.6216188
  },
  {
    lane: 'JFKLAS',
    kg: 262.3962006,
    lbs: 578.4846766
  },
  {
    lane: 'JFKLAX',
    kg: 439.56657874,
    lbs: 969.078552
  },
  {
    lane: 'JFKPHX',
    kg: 319.15745123,
    lbs: 703.6218304
  },
  {
    lane: 'JFKSFO',
    kg: 457.15799875,
    lbs: 1007.861
  },
  {
    lane: 'LAXATL',
    kg: 493.10609633,
    lbs: 1087.112999
  },
  {
    lane: 'LAXHNL',
    kg: 430.24511745,
    lbs: 948.5282449
  },
  {
    lane: 'LAXJFK',
    kg: 474.048868,
    lbs: 1045.098997
  },
  {
    lane: 'LAXOGG',
    kg: 331.89060988,
    lbs: 731.6936437
  },
  {
    lane: 'MSPHNL',
    kg: 516.48231345,
    lbs: 1138.648743
  },
  {
    lane: 'SEAATL',
    kg: 323.5988187,
    lbs: 713.4133709
  },
  {
    lane: 'AMSATL',
    kg: 522.89622474,
    lbs: 1152.788999
  },
  {
    lane: 'AMSBOS',
    kg: 592.2389918,
    lbs: 1305.663652
  },
  {
    lane: 'AMSDTW',
    kg: 598.58845955,
    lbs: 1319.661834
  },
  {
    lane: 'AMSJFK',
    kg: 588.99083919,
    lbs: 1298.502701
  },
  {
    lane: 'AMSMSP',
    kg: 543.96375714,
    lbs: 1199.234964
  },
  {
    lane: 'AMSSEA',
    kg: 628.30841357,
    lbs: 1385.183126
  },
  {
    lane: 'AMSSLC',
    kg: 524.22639357,
    lbs: 1155.72152
  },
  {
    lane: 'AMSTPA',
    kg: 555.90053975,
    lbs: 1225.551068
  },
  {
    lane: 'ATLAMS',
    kg: 524.35050114,
    lbs: 1155.99513
  },
  {
    lane: 'ATLATH',
    kg: 547.4171378,
    lbs: 1206.848366
  },
  {
    lane: 'ATLBCN',
    kg: 473.63780742,
    lbs: 1044.192764
  },
  {
    lane: 'ATLBOG',
    kg: 305.94239067,
    lbs: 674.487605
  },
  {
    lane: 'ATLBRU',
    kg: 744.35945274,
    lbs: 1641.031906
  },
  {
    lane: 'ATLCDG',
    kg: 725.60425821,
    lbs: 1599.683775
  },
  {
    lane: 'ATLCPT',
    kg: 100.24391377,
    lbs: 221.0000294
  },
  {
    lane: 'ATLDUB',
    kg: 728.34691173,
    lbs: 1605.730291
  },
  {
    lane: 'ATLEDI',
    kg: 538.41479735,
    lbs: 1187.0016
  },
  {
    lane: 'ATLEZE',
    kg: 580.22950651,
    lbs: 1279.187266
  },
  {
    lane: 'ATLFCO',
    kg: 528.74911092,
    lbs: 1165.692406
  },
  {
    lane: 'ATLFRA',
    kg: 522.75615131,
    lbs: 1152.48019
  },
  {
    lane: 'ATLGIG',
    kg: 370.10960364,
    lbs: 815.9521131
  },
  {
    lane: 'ATLGRU',
    kg: 447.5778481,
    lbs: 986.74038
  },
  {
    lane: 'ATLHND',
    kg: 489.57890669,
    lbs: 1079.336876
  },
  {
    lane: 'ATLICN',
    kg: 468.48602415,
    lbs: 1032.835024
  },
  {
    lane: 'ATLJNB',
    kg: 605.46690107,
    lbs: 1334.826204
  },
  {
    lane: 'ATLLHR',
    kg: 616.66196527,
    lbs: 1359.507099
  },
  {
    lane: 'ATLLIM',
    kg: 423.93322306,
    lbs: 934.6128979
  },
  {
    lane: 'ATLLOS',
    kg: 421.77105402,
    lbs: 929.8461304
  },
  {
    lane: 'ATLMAD',
    kg: 582.85038159,
    lbs: 1284.965307
  },
  {
    lane: 'ATLMUC',
    kg: 453.58764921,
    lbs: 999.9897253
  },
  {
    lane: 'ATLMXP',
    kg: 717.18249758,
    lbs: 1581.116968
  },
  {
    lane: 'ATLNCE',
    kg: 125.15153078,
    lbs: 275.9119326
  },
  {
    lane: 'ATLSCL',
    kg: 444.395277,
    lbs: 979.7240109
  },
  {
    lane: 'ATLSJU',
    kg: 451.55521195,
    lbs: 995.5089675
  },
  {
    lane: 'ATLUIO',
    kg: 251.87783946,
    lbs: 555.2956566
  },
  {
    lane: 'ATLVCE',
    kg: 439.47378343,
    lbs: 968.8739734
  },
  {
    lane: 'ATLZRH',
    kg: 400.83468427,
    lbs: 883.6893299
  },
  {
    lane: 'BOSAMS',
    kg: 514.99345847,
    lbs: 1135.366379
  },
  {
    lane: 'BOSATH',
    kg: 60.510129343,
    lbs: 133.4020177
  },
  {
    lane: 'BOSBCN',
    kg: 318.05443392,
    lbs: 701.1900931
  },
  {
    lane: 'BOSCDG',
    kg: 322.85173193,
    lbs: 711.7663263
  },
  {
    lane: 'BOSDUB',
    kg: 659.03955039,
    lbs: 1452.933694
  },
  {
    lane: 'BOSFCO',
    kg: 75.012838189,
    lbs: 165.375022
  },
  {
    lane: 'BOSLHR',
    kg: 424.27564047,
    lbs: 935.3677991
  },
  {
    lane: 'BOSLIS',
    kg: 143.3281574,
    lbs: 315.9845401
  },
  {
    lane: 'BOSMAD',
    kg: 536.4251885,
    lbs: 1182.615263
  },
  {
    lane: 'BOSMXP',
    kg: 531.72912808,
    lbs: 1172.26222
  },
  {
    lane: 'CDGATL',
    kg: 432.03606584,
    lbs: 952.4766107
  },
  {
    lane: 'CDGBOS',
    kg: 470.8577355,
    lbs: 1038.063753
  },
  {
    lane: 'CDGCVG',
    kg: 441.91617151,
    lbs: 974.2585181
  },
  {
    lane: 'CDGDTW',
    kg: 456.76640737,
    lbs: 1006.997688
  },
  {
    lane: 'CDGJFK',
    kg: 447.51778996,
    lbs: 986.6079745
  },
  {
    lane: 'CDGLAX',
    kg: 440.53706195,
    lbs: 971.2181015
  },
  {
    lane: 'CDGMSP',
    kg: 562.66529308,
    lbs: 1240.464798
  },
  {
    lane: 'CDGSEA',
    kg: 519.557574,
    lbs: 1145.428533
  },
  {
    lane: 'CDGSLC',
    kg: 470.50008858,
    lbs: 1037.275277
  },
  {
    lane: 'DTWAMS',
    kg: 565.24032515,
    lbs: 1246.141773
  },
  {
    lane: 'DTWCDG',
    kg: 512.45593,
    lbs: 1129.772086
  },
  {
    lane: 'DTWDUB',
    kg: 520.59885973,
    lbs: 1147.724176
  },
  {
    lane: 'DTWFCO',
    kg: 581.38228363,
    lbs: 1281.728705
  },
  {
    lane: 'DTWFRA',
    kg: 549.57403354,
    lbs: 1211.603508
  },
  {
    lane: 'DTWHND',
    kg: 569.28527437,
    lbs: 1255.059361
  },
  {
    lane: 'DTWICN',
    kg: 363.23434045,
    lbs: 800.7947504
  },
  {
    lane: 'DTWLHR',
    kg: 567.08163242,
    lbs: 1250.201161
  },
  {
    lane: 'DTWMUC',
    kg: 720.61181831,
    lbs: 1588.677327
  },
  {
    lane: 'DTWPVG',
    kg: 481.45645066,
    lbs: 1061.429924
  },
  {
    lane: 'EZEATL',
    kg: 466.01687652,
    lbs: 1027.391485
  },
  {
    lane: 'FCOATL',
    kg: 636.63859608,
    lbs: 1403.548037
  },
  {
    lane: 'FCOBOS',
    kg: 550.56843424,
    lbs: 1213.795786
  },
  {
    lane: 'FCODTW',
    kg: 541.20190881,
    lbs: 1193.14613
  },
  {
    lane: 'FCOJFK',
    kg: 586.41486831,
    lbs: 1292.823656
  },
  {
    lane: 'FCOMSP',
    kg: 525.25029742,
    lbs: 1157.978842
  },
  {
    lane: 'FCOSEA',
    kg: 470.91237954,
    lbs: 1038.184223
  },
  {
    lane: 'FRAATL',
    kg: 813.98284255,
    lbs: 1794.525227
  },
  {
    lane: 'FRADTW',
    kg: 741.48377998,
    lbs: 1634.692132
  },
  {
    lane: 'FRAJFK',
    kg: 604.70318018,
    lbs: 1333.142488
  },
  {
    lane: 'GRUJFK',
    kg: 482.12728983,
    lbs: 1062.908871
  },
  {
    lane: 'HNDATL',
    kg: 695.28520169,
    lbs: 1532.841688
  },
  {
    lane: 'HNDDTW',
    kg: 544.49945103,
    lbs: 1200.415967
  },
  {
    lane: 'HNDHNL',
    kg: 584.77468691,
    lbs: 1289.207675
  },
  {
    lane: 'HNDLAX',
    kg: 456.43219595,
    lbs: 1006.260878
  },
  {
    lane: 'HNDMSP',
    kg: 727.95687823,
    lbs: 1604.870415
  },
  {
    lane: 'HNDSEA',
    kg: 425.06292134,
    lbs: 937.1034566
  },
  {
    lane: 'ICNATL',
    kg: 446.12964748,
    lbs: 983.5476438
  },
  {
    lane: 'ICNDTW',
    kg: 563.68422736,
    lbs: 1242.711164
  },
  {
    lane: 'ICNMSP',
    kg: 525.6291873,
    lbs: 1158.814151
  },
  {
    lane: 'ICNSEA',
    kg: 492.93797945,
    lbs: 1086.742365
  },
  {
    lane: 'ICNSLC',
    kg: 492.136249,
    lbs: 1084.974852
  },
  {
    lane: 'JFKACC',
    kg: 261.47791103,
    lbs: 576.4601943
  },
  {
    lane: 'JFKAMS',
    kg: 471.10045439,
    lbs: 1038.598857
  },
  {
    lane: 'JFKARN',
    kg: 367.16853211,
    lbs: 809.4681594
  },
  {
    lane: 'JFKATH',
    kg: 501.55626007,
    lbs: 1105.742424
  },
  {
    lane: 'JFKBCN',
    kg: 883.54934127,
    lbs: 1947.893124
  },
  {
    lane: 'JFKBER',
    kg: 478.4775725,
    lbs: 1054.86262
  },
  {
    lane: 'JFKCDG',
    kg: 407.39939735,
    lbs: 898.1620468
  },
  {
    lane: 'JFKCPH',
    kg: 558.28636216,
    lbs: 1230.810907
  },
  {
    lane: 'JFKDSS',
    kg: 521.20646457,
    lbs: 1149.063715
  },
  {
    lane: 'JFKDUB',
    kg: 505.318002,
    lbs: 1114.035646
  },
  {
    lane: 'JFKEDI',
    kg: 41.593436702,
    lbs: 91.69784365
  },
  {
    lane: 'JFKFCO',
    kg: 457.80873534,
    lbs: 1009.295628
  },
  {
    lane: 'JFKFRA',
    kg: 429.04384244,
    lbs: 945.8798865
  },
  {
    lane: 'JFKGRU',
    kg: 347.72265245,
    lbs: 766.5973275
  },
  {
    lane: 'JFKKEF',
    kg: 196.33474255,
    lbs: 432.8440724
  },
  {
    lane: 'JFKLHR',
    kg: 448.62550315,
    lbs: 989.0500644
  },
  {
    lane: 'JFKLIS',
    kg: 414.74742814,
    lbs: 914.3616839
  },
  {
    lane: 'JFKMAD',
    kg: 555.12259644,
    lbs: 1223.835997
  },
  {
    lane: 'JFKMXP',
    kg: 421.52589749,
    lbs: 929.3056527
  },
  {
    lane: 'JFKNCE',
    kg: 227.2148525,
    lbs: 500.9230704
  },
  {
    lane: 'JFKPRG',
    kg: 571.20563787,
    lbs: 1259.293038
  },
  {
    lane: 'JFKVCE',
    kg: 546.70821474,
    lbs: 1205.285458
  },
  {
    lane: 'JFKZRH',
    kg: 590.1460784,
    lbs: 1301.049567
  },
  {
    lane: 'LAXAKL',
    kg: 320.68972004,
    lbs: 706.9999053
  },
  {
    lane: 'LAXCDG',
    kg: 427.79974121,
    lbs: 943.1371124
  },
  {
    lane: 'LAXHND',
    kg: 243.96871373,
    lbs: 537.8590168
  },
  {
    lane: 'LAXMEL',
    kg: 463.46225818,
    lbs: 1021.759514
  },
  {
    lane: 'LAXPVG',
    kg: 703.24078993,
    lbs: 1550.38076
  },
  {
    lane: 'LAXSYD',
    kg: 922.16878631,
    lbs: 2033.034438
  },
  {
    lane: 'LHRATL',
    kg: 357.59791683,
    lbs: 788.3685617
  },
  {
    lane: 'LHRBOS',
    kg: 351.99035543,
    lbs: 776.0060033
  },
  {
    lane: 'LHRDTW',
    kg: 423.48525728,
    lbs: 933.6253022
  },
  {
    lane: 'LHRJFK',
    kg: 361.33516162,
    lbs: 796.6077772
  },
  {
    lane: 'LHRMSP',
    kg: 336.09096858,
    lbs: 740.9538508
  },
  {
    lane: 'LHRSEA',
    kg: 370.06672923,
    lbs: 815.8575912
  },
  {
    lane: 'LHRSLC',
    kg: 414.34339409,
    lbs: 913.4709412
  },
  {
    lane: 'MSPAMS',
    kg: 530.80704293,
    lbs: 1170.22937
  },
  {
    lane: 'MSPCDG',
    kg: 485.90485178,
    lbs: 1071.236971
  },
  {
    lane: 'MSPCPH',
    kg: 422.07097092,
    lbs: 930.5073341
  },
  {
    lane: 'MSPDUB',
    kg: 471.70140915,
    lbs: 1039.923736
  },
  {
    lane: 'MSPFCO',
    kg: 371.00796637,
    lbs: 817.9326642
  },
  {
    lane: 'MSPHND',
    kg: 314.8872252,
    lbs: 694.2075922
  },
  {
    lane: 'MSPICN',
    kg: 449.15256036,
    lbs: 990.2120268
  },
  {
    lane: 'MSPLHR',
    kg: 420.37582538,
    lbs: 926.7701774
  },
  {
    lane: 'MXPATL',
    kg: 650.23722044,
    lbs: 1433.527876
  },
  {
    lane: 'MXPJFK',
    kg: 607.41323426,
    lbs: 1339.117135
  },
  {
    lane: 'PVGDTW',
    kg: 664.67087685,
    lbs: 1465.348646
  },
  {
    lane: 'PVGLAX',
    kg: 619.38806438,
    lbs: 1365.51712
  },
  {
    lane: 'PVGSEA',
    kg: 507.32495037,
    lbs: 1118.460211
  },
  {
    lane: 'SCLATL',
    kg: 808.46477409,
    lbs: 1782.359967
  },
  {
    lane: 'SEAAMS',
    kg: 458.20607625,
    lbs: 1010.171615
  },
  {
    lane: 'SEABCN',
    kg: 136.077711,
    lbs: 300.0000398
  },
  {
    lane: 'SEACDG',
    kg: 417.24663456,
    lbs: 919.8714916
  },
  {
    lane: 'SEAFCO',
    kg: 103.49998124,
    lbs: 228.1784303
  },
  {
    lane: 'SEAHND',
    kg: 490.41047814,
    lbs: 1081.170178
  },
  {
    lane: 'SEAICN',
    kg: 386.93076972,
    lbs: 853.0364413
  },
  {
    lane: 'SEALHR',
    kg: 526.57658515,
    lbs: 1160.902806
  },
  {
    lane: 'SEAPVG',
    kg: 623.59577327,
    lbs: 1374.793531
  },
  {
    lane: 'SEATPE',
    kg: 369.77805094,
    lbs: 815.2211645
  },
  {
    lane: 'TPESEA',
    kg: 551.03377795,
    lbs: 1214.821694
  }
]

export default constants